export default "__VITE_ASSET__DseApgvW__"